import { Fragment } from "react";

import Section from "../section/section";

import "./footer.scss";

import Link from "../link/link";
import Icon from "../icon/icon";

function Footer(props) {
  return (
    <Fragment>
      {/* contact */}
      <Section
        id="contact"
        className="contact"
        centered
        greyFullwidthBg
      >
        <div className="contact__info">
          <p className="contact__headline">Kontakt</p>
          <p>Kontaktieren Sie mich gerne!</p>
          <p>Ich freue mich über ein Projekt mit Ihnen!</p>
        </div>

        <div className="contact__button-wrapper">
          <a
            target="_blank"
            href="mailto:contact@lennartkallert.de"
            className="contact__button"
            rel="noreferrer"
            aria-label="Email an Lennart"
          >
            <Icon className="contact__button-icon" type="icons" name="mail" />
            <div className="contact__button-info">
              Email:
              <span className="contact__button-link">
                contact@lennartkallert.de
              </span>
            </div>
          </a>
          <a
            target="_blank"
            className="contact__button"
            href="https://www.linkedin.com/in/lennartkallert/"
            rel="noreferrer"
            aria-label="Link zu Lennart LinkedIn Profil"
          >
            <Icon
              className="contact__button-icon"
              type="icons"
              name="linkedin"
            />
            <div className="contact__button-info">
              LinkedIn:
              <span className="contact__button-link">lennartkallert</span>
            </div>
          </a>
          <a
            target="_blank"
            className="contact__button"
            href="tel:+4917644278826"
            rel="noreferrer"
            aria-label="Ruft Lennart auf dem Telefon an"
          >
            <Icon
              className="contact__button-icon"
              type="icons"
              name="telefon"
            />
            <div className="contact__button-info">
              Phone:
              <span className="contact__button-link">+49 176 44 27 88 26</span>
            </div>
          </a>
        </div>
      </Section>

      {/* footer */}
      <footer className="footer l-container">
        <Link href="/" className="footer__home-link" text="Home" internLink aria-label="Linkt to home" />
        <div className="separator">|</div>
        <Link
          href="/impressum"
          className="footer__impressum-link"
          text="Impressum"
          internLink
          aria-label="Linkt to impressum"
        />
      </footer>
    </Fragment>
  );
}

export default Footer;
